<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { acceptMemberInvitation, inspectMemberInvitation } from '@/api/index.js'
import { authStore } from '@/stores/auth.js'

const route = useRoute()
const router = useRouter()
const invitation = ref(null)
const error = ref('')
const busy = ref(false)
const token = computed(() => String(route.params.token || ''))

onMounted(async () => {
  try { invitation.value = await inspectMemberInvitation(token.value) }
  catch (err) { error.value = err?.message || '邀请链接不存在或已失效。' }
})

async function accept() {
  busy.value = true
  error.value = ''
  try {
    if (!await authStore.ensureSession()) {
      await router.push({ name: 'login', query: { next: route.fullPath } })
      return
    }
    invitation.value = await acceptMemberInvitation(token.value)
    authStore.state.sessionChecked = false
    await authStore.ensureSession()
    await router.replace(await authStore.prepareDefaultTenant())
  } catch (err) {
    error.value = err?.message || '暂时无法加入企业空间。'
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <section class="entry-layout" aria-labelledby="invite-title">
    <div class="entry-copy">
      <p class="eyebrow">CLOUD INVITATION</p>
      <h1 id="invite-title">加入企业云端空间</h1>
      <p class="entry-summary">全程使用浏览器云端网址，不下载、不启动、不经过桌面安装程序。</p>
    </div>
    <div class="entry-card">
      <h2>{{ invitation?.tenant_name || '正在核对邀请…' }}</h2>
      <p v-if="invitation">受邀账号：{{ invitation.masked_email }}</p>
      <p v-if="invitation?.status !== 'pending'">状态：{{ invitation?.status }}</p>
      <p v-if="error" class="form-error" role="alert">{{ error }}</p>
      <button v-if="invitation?.status === 'pending'" type="button" :disabled="busy" @click="accept">
        {{ busy ? '正在加入…' : '登录并加入企业空间' }}
      </button>
    </div>
  </section>
</template>
